"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitlistJoinDataDtoStatusEnum = void 0;
exports.instanceOfWaitlistJoinDataDto = instanceOfWaitlistJoinDataDto;
exports.WaitlistJoinDataDtoFromJSON = WaitlistJoinDataDtoFromJSON;
exports.WaitlistJoinDataDtoFromJSONTyped = WaitlistJoinDataDtoFromJSONTyped;
exports.WaitlistJoinDataDtoToJSON = WaitlistJoinDataDtoToJSON;
exports.WaitlistJoinDataDtoToJSONTyped = WaitlistJoinDataDtoToJSONTyped;
/**
 * @export
 */
exports.WaitlistJoinDataDtoStatusEnum = {
    Pending: 'pending',
    Invited: 'invited',
    Joined: 'joined'
};
/**
 * Check if a given object implements the WaitlistJoinDataDto interface.
 */
function instanceOfWaitlistJoinDataDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined)
        return false;
    if (!('isNew' in value) || value['isNew'] === undefined)
        return false;
    return true;
}
function WaitlistJoinDataDtoFromJSON(json) {
    return WaitlistJoinDataDtoFromJSONTyped(json, false);
}
function WaitlistJoinDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'email': json['email'],
        'status': json['status'],
        'createdAt': (new Date(json['createdAt'])),
        'isNew': json['isNew'],
    };
}
function WaitlistJoinDataDtoToJSON(json) {
    return WaitlistJoinDataDtoToJSONTyped(json, false);
}
function WaitlistJoinDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'email': value['email'],
        'status': value['status'],
        'createdAt': value['createdAt'].toISOString(),
        'isNew': value['isNew'],
    };
}
